<template>
  <div
    :class="cardStyle['guide-card']"
    @click="openCollapse"
    :aria-expanded="visible ? 'true' : 'false'"
    :aria-controls="`sidebar_guide_${userInfo.userId}`"
  >
    <div :class="cardStyle['guide-badge']">
      <h4
        v-if="guide.profile && guide.profile.rating"
        :class="cardStyle.rating"
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.1892 6.01718L10.222 5.44062L8.44859 1.84531C8.40015 1.74687 8.32046 1.66718 8.22203 1.61875C7.97515 1.49687 7.67515 1.59843 7.55171 1.84531L5.77828 5.44062L1.81109 6.01718C1.70171 6.03281 1.60171 6.08437 1.52515 6.1625C1.43259 6.25763 1.38159 6.38562 1.38334 6.51834C1.3851 6.65106 1.43948 6.77766 1.53453 6.87031L4.40484 9.66875L3.72671 13.6203C3.71081 13.7122 3.72098 13.8068 3.75608 13.8932C3.79117 13.9796 3.84978 14.0545 3.92526 14.1093C4.00074 14.1642 4.09007 14.1967 4.18312 14.2034C4.27617 14.21 4.36922 14.1904 4.45171 14.1469L8.00015 12.2812L11.5486 14.1469C11.6455 14.1984 11.758 14.2156 11.8658 14.1969C12.1377 14.15 12.3205 13.8922 12.2736 13.6203L11.5955 9.66875L14.4658 6.87031C14.5439 6.79375 14.5955 6.69375 14.6111 6.58437C14.6533 6.31093 14.4627 6.05781 14.1892 6.01718Z"
            fill="#EABA26"
          />
        </svg>
        <span>{{ guide.profile.rating }}</span>
      </h4>
    </div>
    <div :class="cardStyle.user">
      <img v-if="userInfo.imgURL" :src="userInfo.imgURL" alt="" />
      <empty-avatar
        v-else
        :firstname="userInfo.firstname"
        :lastname="userInfo.lastname"
      />
      <div :class="cardStyle['user-info']">
        <h3 :class="cardStyle['hide-name']">
          {{ userInfo.firstname }} {{ userInfo.lastname }}
        </h3>
        <p :class="cardStyle['hide-describe']">
          {{ mainline || "Build Technology" }}
        </p>
      </div>
    </div>
    <div :class="cardStyle.foot">
      <span v-if="hasCharityPlan" class="charity">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.9">
            <path
              d="M5.92944 5.11759C5.92945 7.96936 9.74295 11.4802 11.9932 12.9116C14.4128 11.3528 18.0271 8.6764 18.0271 5.44116C18.0271 3.90472 17.131 2 15.279 2C13.7974 2 12.6205 2.64709 11.9932 3.8235C11.3361 2.61768 9.60355 2 8.76717 2C7.93079 2 5.92944 2 5.92944 5.11759Z"
              stroke="#52595E"
            />
            <path
              d="M7.72155 17.8233C7.67176 17.5586 7.15401 16.6763 7.15401 16.6763L5.45137 15.0587C5.45137 15.0587 4.55525 14.1175 4.01758 13.4999C3.4799 12.8822 3.43016 12.3234 3.56956 11.9705C3.65425 11.7561 3.95788 11.5881 4.07736 11.5881M4.07736 11.5881C4.22672 11.5587 4.61504 11.6176 4.85396 11.8528C5.12284 12.1175 6.40724 13.3822 7.15401 14.1175C7.90078 14.8528 10.2905 15.8233 10.7087 16.8527C11.1269 17.8821 10.8282 20.3821 10.8282 22.0879L6.67608 22.1174C6.80552 21.6468 6.67608 20.6762 6.67608 19.8233C6.67608 18.5021 5.15271 17.3822 4.67478 17.0292C4.19686 16.6763 2.16558 15.0587 2.16558 14.1175C2.16557 12.2902 1.89441 8.76157 2.04612 7.52938C2.16561 6.55881 2.28506 6.02939 2.82274 6.23527C3.36041 6.44115 3.59938 6.87057 3.59938 7.64703C3.59938 8.42349 3.93797 10.6 4.07736 11.5881Z"
              stroke="#52595E"
            />
            <path
              d="M16.2784 17.8233C16.3282 17.5586 16.846 16.6763 16.846 16.6763L18.5486 15.0587C18.5486 15.0587 19.4447 14.1175 19.9824 13.4999C20.5201 12.8822 20.5698 12.3234 20.4304 11.9705C20.3458 11.7561 20.0421 11.5881 19.9226 11.5881M19.9226 11.5881C19.7733 11.5587 19.385 11.6176 19.146 11.8528C18.8772 12.1175 17.5928 13.3822 16.846 14.1175C16.0992 14.8528 13.7095 15.8233 13.2913 16.8527C12.8731 17.8821 13.1718 20.3821 13.1718 22.0879L17.3239 22.1174C17.1945 21.6468 17.3239 20.6762 17.3239 19.8233C17.3239 18.5021 18.8473 17.3822 19.3252 17.0292C19.8031 16.6763 21.8344 15.0587 21.8344 14.1175C21.8344 12.2902 22.1056 8.76157 21.9539 7.52938C21.8344 6.55881 21.7149 6.02939 21.1773 6.23527C20.6396 6.44115 20.4006 6.87057 20.4006 7.64703C20.4006 8.42349 20.062 10.6 19.9226 11.5881Z"
              stroke="#52595E"
            />
          </g>
        </svg>
      </span>
      <h5 class="ml-2">${{ plans.lenght === 0 || 75 }}/session</h5>
      <div :class="cardStyle.social">
        <a
          v-if="
            guide.profile &&
              guide.profile.social &&
              guide.profile.social.facebookURL
          "
          :href="`https://facebook.com/${guide.profile.social.facebookURL}`"
          target="_blank"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 20.0002C15.5228 20.0002 20 15.523 20 10.0002C20 4.47734 15.5228 0.000183105 10 0.000183105C4.47715 0.000183105 0 4.47734 0 10.0002C0 15.523 4.47715 20.0002 10 20.0002Z"
              fill="#3B5998"
            />
            <path
              d="M12.5139 10.3911H10.7295V16.9282H8.02602V10.3911H6.74023V8.09368H8.02602V6.60699C8.02602 5.54385 8.53103 3.87909 10.7536 3.87909L12.7561 3.88747V6.11749H11.3031C11.0648 6.11749 10.7297 6.23657 10.7297 6.74372V8.09582H12.7501L12.5139 10.3911Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          v-if="
            guide.profile &&
              guide.profile.social &&
              guide.profile.social.twitterURL
          "
          :href="`https://facebook.com/${guide.profile.social.twitterURL}`"
          target="_blank"
        >
          <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 2.79748C19.2641 3.12382 18.4733 3.34439 17.6433 3.44359C18.4905 2.93574 19.1411 2.13162 19.4475 1.1735C18.6547 1.64367 17.7765 1.98516 16.8419 2.16922C16.0933 1.37175 15.027 0.873413 13.8468 0.873413C11.5807 0.873413 9.74344 2.71057 9.74344 4.97656C9.74344 5.29815 9.7798 5.61133 9.84974 5.91164C6.43952 5.74053 3.41607 4.10696 1.3923 1.6245C1.0391 2.23052 0.836753 2.93538 0.836753 3.68734C0.836753 5.11088 1.56121 6.36681 2.6622 7.10261C1.98954 7.08132 1.35689 6.89675 0.803614 6.58942C0.803321 6.60654 0.803321 6.62373 0.803321 6.641C0.803321 8.62907 2.21771 10.2875 4.09481 10.6644C3.75047 10.7582 3.38798 10.8083 3.01372 10.8083C2.74933 10.8083 2.49226 10.7826 2.24178 10.7347C2.76389 12.3649 4.27923 13.5512 6.07476 13.5843C4.67047 14.6848 2.9012 15.3408 0.978821 15.3408C0.647646 15.3408 0.321007 15.3214 0 15.2835C1.81587 16.4477 3.97271 17.127 6.28992 17.127C13.8372 17.127 17.9644 10.8746 17.9644 5.45237C17.9644 5.27445 17.9604 5.09749 17.9525 4.92155C18.7542 4.34304 19.4499 3.62033 20 2.79748Z"
              fill="#55ACEE"
            />
          </svg>
        </a>
        <a
          v-if="
            guide.profile &&
              guide.profile.social &&
              guide.profile.social.instagramURL
          "
          :href="`https://facebook.com/${guide.profile.social.instagramURL}`"
          target="_blank"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.0032 5.35107C7.88381 5.35107 5.3584 7.87924 5.3584 10.9959C5.3584 14.1153 7.88656 16.6407 11.0032 16.6407C14.1226 16.6407 16.6481 14.1126 16.6481 10.9959C16.6481 7.87649 14.1199 5.35107 11.0032 5.35107ZM11.0032 14.6598C8.97831 14.6598 7.33931 13.0199 7.33931 10.9959C7.33931 8.97191 8.97923 7.33199 11.0032 7.33199C13.0272 7.33199 14.6671 8.97191 14.6671 10.9959C14.6681 13.0199 13.0281 14.6598 11.0032 14.6598Z"
              fill="#FF0FFF"
            />
            <path
              d="M15.5359 0.0691044C13.5119 -0.0253122 8.49863 -0.0207289 6.47279 0.0691044C4.69263 0.152521 3.12238 0.582438 1.85646 1.84835C-0.259208 3.96402 0.0112083 6.81486 0.0112083 10.9958C0.0112083 15.2748 -0.227125 18.0596 1.85646 20.1432C3.98038 22.2662 6.87246 21.9884 11.0039 21.9884C15.2425 21.9884 16.7055 21.9912 18.2043 21.4109C20.242 20.6199 21.7802 18.7984 21.9305 15.5269C22.0259 13.5019 22.0204 8.4896 21.9305 6.46377C21.749 2.60186 19.6765 0.259771 15.5359 0.0691044ZM18.7396 18.7434C17.3527 20.1304 15.4286 20.0066 10.9773 20.0066C6.39396 20.0066 4.55604 20.0744 3.21496 18.7297C1.67038 17.1924 1.94996 14.7239 1.94996 10.9811C1.94996 5.91652 1.43021 2.2691 6.51313 2.00877C7.68096 1.96752 8.02471 1.95377 10.9645 1.95377L11.0057 1.98127C15.8906 1.98127 19.7232 1.46977 19.9533 6.55177C20.0055 7.71136 20.0175 8.05969 20.0175 10.9949C20.0165 15.525 20.1027 17.3739 18.7396 18.7434Z"
              fill="#FF0FFF"
            />
            <path
              d="M16.8718 6.44724C17.6003 6.44724 18.1909 5.85667 18.1909 5.12816C18.1909 4.39965 17.6003 3.80908 16.8718 3.80908C16.1433 3.80908 15.5527 4.39965 15.5527 5.12816C15.5527 5.85667 16.1433 6.44724 16.8718 6.44724Z"
              fill="#FF0FFF"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import emptyAvatar from "@/components/jab/emptyAvatar";
export default {
  name: "GuideCard",
  components: {
    emptyAvatar
  },
  props: {
    guide: {
      tyoe: Object,
      require: true
    },
    cardStyle: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      visible: null
    };
  },
  methods: {
    openCollapse() {
      // this.$root.$emit('bv::toggle::collapse', 'my-collapse-id')
      // this.$nextTick(() => {
      this.$emit("toggleCollapse", this.userInfo.userId);
      // })
    }
  },
  computed: {
    userInfo() {
      return this.guide.user;
    },
    plans() {
      const c = this.guide;
      const pofile = c.profile || c.profile_update;
      return pofile || [];
    },
    hasCharityPlan() {
      let hasCharityPlan = false;
      if (this.guide.profile && this.guide.profile.plans) {
        this.guide.profile.plans.forEach(plan => {
          if (plan.charity) {
            hasCharityPlan = true;
          }
        });
      }
      return hasCharityPlan;
    },
    mainline() {
      let mainline = "";
      if (this.guide.profile && this.guide.profile.tags) {
        this.guide.profile.tags.forEach(tag => {
          mainline += `${tag.text} `;
        });
      }
      return mainline;
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-fill {
  font-family: "Nunito", sans-serif;
  width: 62px;
  height: 24px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  padding: 0;
  border-radius: 20px;
}
.charity {
  margin-right: -60px;
}
</style>
